import Banner from '@rio-cloud/rio-uikit/Banner';
import { FormattedMessage } from 'react-intl';

export const AssetAdministrationMaintenanceBanner = () => {
    return (
        <Banner show dismissible={false} initialAnimation={false} className='margin-bottom-20'>
            <Banner.Page>
                <Banner.Icon>
                    <span aria-hidden='true' className='uikit-icon icon-warning-sign text-color-warning text-size-20' />
                </Banner.Icon>
                <Banner.Content>
                    <FormattedMessage id='intl-msg:create-new-dialog.telematics.asset-administration-maintenance' />
                </Banner.Content>
            </Banner.Page>
        </Banner>
    );
};
